import * as actions from './actions';
import * as getters from './getters';
import moment from 'moment';

import {
    CREATE_QUOTE,
    CLEAR_QUOTE,
    FETCH_QUOTE,
    FETCH_CURRENCIES,
    FETCH_LOCATIONS,
    SET_CURRENCY,
    CREATE_VEHICLE,
    UPDATE_VEHICLE,
    DELETE_VEHICLE,
    FETCH_VEHICLES,
    CLEAR_VEHICLES,
    FETCH_VEHICLE_INSURANCE_OPTIONS,
    CREATE_VEHICLE_INSURANCE_OPTION,
    UPDATE_VEHICLE_INSURANCE_OPTION,
    DELETE_VEHICLE_INSURANCE_OPTION,
    CREATE_EXTRA,
    UPDATE_EXTRA,
    DELETE_EXTRA,
    FETCH_EXTRAS,
    UPDATE_DONATION,
    FETCH_TOTALS,
    FETCH_DONATIONS,
    CREATE_CUSTOMER,
    UPDATE_CUSTOMER,
    SET_CUSTOMER_STATE,
    SET_PICKUP_DATE,
    SET_PICKUP_TIME,
    SET_DROPOFF_DATE,
    SET_DROPOFF_TIME,
    SET_PICKUP_LOCATION,
    SET_DROPOFF_LOCATION,
    CREATE_BOOKING,
    TOGGLE_PREMIUM_VEHICLE_UPGRADE,
    SET_SELECTED_VEHICLE_TYPE,
} from './mutation-types';

// initial state
const initialState = {
    quote: {
        id: null,
        source_id: null,
        pickup_location: {
            data: {
                id: null,
                name: null,
            },
        },
        pickup_location_id: null,
        dropoff_location: {
            data: {
                id: null,
                name: null,
            },
        },
        dropoff_location_id: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        age: null,
        promo_code: null,
        loyalty_discount: null,
        birthday_loyalty_discount_applied: null,
        green_heart_donation: false,
        currency: null,
        converted_currency: null,
        locale: null,
        guest_token: null,
        payment_type: 'PP',
        pay_on_arrival_available: true,
        selected_vehicle: {
            data: {
                id: null,
                total: 0,
                vehicle: {
                    data: {
                        acriss: null,
                        adults: 0,
                        air_conditioning: 0,
                        children: 0,
                        co2: 0,
                        currency: null,
                        discount: 0,
                        discount_percentage: null,
                        excess: 0,
                        fuel: null,
                        group: null,
                        id: null,
                        image: null,
                        loyalty_discount_applied: null,
                        luggage_large: 0,
                        luggage_medium: 0,
                        luggage_small: 0,
                        mpg: null,
                        name: null,
                        original_price: 0,
                        poa_deposit: 0,
                        total_poa: 0,
                        total_pp: 0,
                        transmission: null,
                    },
                },
                selected_insurance_options: {
                    data: [],
                },
            },
        },
        selected_extras: {
            data: [],
        },
        totals: {
            data: {
                green_heart_donation: 0,
                pay_on_arrival: 0,
                pay_online: 0,
                total: 0,
            },
        },
    },
    vehicles: [],
    currencyCode: 'GBP',
    currency: {
        code: localStorage.getItem('currency') || window.greenmotion.defaultCurrency || 'GBP',
        name: 'Pound Sterling',
        symbol: '£',
    },
    currencies: [
        {
            code: 'EUR',
            name: 'Euro',
            symbol: '€',
        },
        {
            code: 'USD',
            name: 'US Dollar',
            symbol: '$',
        },
        {
            code: 'GBP',
            name: 'Pound Sterling',
            symbol: '£',
        },
        {
            code: 'TRY',
            name: 'Turkish Lira',
            symbol: '₺',
        },
    ],
    locations: [],
    vehicleInsuranceOptions: [],
    hasUpgradedVehicle: false,
    selectedVehicleType: 'basic',
    extras: [],
    search: {
        pickupLocation: null,
        dropoffLocation: null,
        pickupDate: moment().format('YYYY-MM-DD'),
        pickupTime: '09:00',
        dropoffDate: moment().format('YYYY-MM-DD'),
        dropoffTime: '09:00',
        driverAge: null,
        promoCode: '',
    },
    createDirect: true,
    donations: [],
};

// mutations
const mutations = {
    [CREATE_QUOTE](state, quote) {
        state.quote = quote;

        let currencyCode =
            quote.user !== undefined || quote.converted_currency
                ? quote.converted_currency
                : quote.user_location_currency;

        state.currencyCode = currencyCode || quote.user_location_currency;
        const currency = state.currencies.filter(currency => {
            return currency.code === state.currencyCode;
        });

        if (currency.length) {
            state.currency = currency[0];
        }

        // Set search params
        state.search.pickupLocation = quote.pickup_location;
        state.search.dropoffDifferent = true;
        state.search.dropoffLocation = quote.dropoff_location;
        state.search.pickupDate = quote.start_date;
        state.search.pickupTime = quote.start_time;
        state.search.dropoffDate = quote.end_date;
        state.search.dropoffTime = quote.end_time;
        state.search.driverAge = quote.age;
        state.search.promoCode = quote.promo_code;
    },

    [CLEAR_QUOTE](state) {
        Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
        });
    },

    [FETCH_CURRENCIES](state, currencies) {
        state.currencies = currencies;
    },

    [FETCH_LOCATIONS](state, locations) {
        state.locations = locations;
    },

    [SET_CURRENCY](state, currency) {
        state.currency = currency;
        state.search.currency = currency;
    },

    [FETCH_VEHICLES](state, vehicles) {
        state.vehicles = vehicles;
    },

    [CLEAR_VEHICLES](state) {
        state.vehicles = [];
    },

    [FETCH_VEHICLE_INSURANCE_OPTIONS](state, insuranceOptions) {
        state.vehicleInsuranceOptions = insuranceOptions;
    },

    [CREATE_EXTRA](state, payload) {
        state.selectedExtras.push(payload.selectedExtra);
        state.selectedExtraIds.push({
            selectedExtraId: payload.selectedExtraId,
            extraId: payload.selectedExtra.id,
        });
    },

    [DELETE_EXTRA](state, selectedExtra) {
        state.quote.selected_extras.data = state.quote.selected_extras.data.filter(extra => {
            return extra.id !== selectedExtra.id;
        });
    },

    [FETCH_EXTRAS](state, extras) {
        state.extras = extras;
    },

    [UPDATE_DONATION](state, donate) {
        state.donate = donate;
    },

    [FETCH_TOTALS](state, totals) {
        state.totals = totals;
    },

    [FETCH_DONATIONS](state, donations) {
        state.donations = donations;
    },

    [SET_CUSTOMER_STATE](state, payload) {
        state.customer[payload.key] = payload.value;
    },

    [DELETE_VEHICLE](state) {
        state.quote.selected_vehicle = initialState.quote.selected_vehicle;
    },

    [SET_PICKUP_DATE](state, date) {
        state.search.pickupDate = date;
    },

    [SET_PICKUP_TIME](state, time) {
        state.search.pickupTime = time;
    },

    [SET_DROPOFF_DATE](state, date) {
        state.search.dropoffDate = date;
    },

    [SET_DROPOFF_TIME](state, time) {
        state.search.dropoffTime = time;
    },

    [SET_PICKUP_LOCATION](state, location) {
        state.search.pickupLocation = location;
    },

    [SET_DROPOFF_LOCATION](state, dateTime) {
        state.search.dropoffLocation = dateTime;
    },

    [CREATE_BOOKING](state, booking) {
        state.booking = booking;
    },

    [TOGGLE_PREMIUM_VEHICLE_UPGRADE](state) {
        state.hasUpgradedVehicle = !state.hasUpgradedVehicle;
    },

    [SET_SELECTED_VEHICLE_TYPE](state, type) {
        state.selectedVehicleType = type;
        state.hasUpgradedVehicle = false;
    },
};

export default {
    state: { ...initialState },
    actions,
    getters,
    mutations,
};
